import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75921629"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 조합원 자격 거래 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('인기 1:1 거래 회사'))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('회사를 선택해서 조합원 자격 매물들을 확인하세요!'))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 매물 모아보기 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 조합원 자격 팔기 ")
const _hoisted_6 = { class: "c_logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_intersect_box = _resolveComponent("ag-intersect-box")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    "model-value": _ctx.modelValue,
    height: "calc(100% - 50px)",
    "safe-area": true,
    "swipe-to-close": true,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, { handle: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s, { css: {color: 'font', dp: 'flex', mx: 20, borderBottom: '1px solid #EEF1F7', minHeight: 40} }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text_s, { css: {typography: 'main16r', grow: 1, textAlign: 'start'} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { onClick: _ctx.onShare }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_icon, {
                    name: "arrowRedo",
                    css: {width: 26, height: 26, color: 'gray6'}
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s, { css: {p: '40px 20px 8px 20px', mb: 'safeAreaBottom', dp: 'flex', direction: 'column'} }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', mb: '8px', dp: 'flex', alignItems: 'flex-end'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, { css: {dp: 'block', mr: '9px', typography: 'tit24b'} }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text_s, { css: {dp: 'block', color:'gray3', typography: 'main12r'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formattedDate(_ctx.updateDate)) + _toDisplayString(' 기준 거래량순'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', mb: '20px', width: '100%' , justifyContent:'space-between', alignItems:'center'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, { css: {dp: 'block', typography: 'main14r'} }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {
            dp:'flex',dd:'row',justifyContent:'space-between',
            typography:'text14r', mb:'24px'

          } }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box_s, {
                    css: {
              border: '1px solid #EEF1F7',
              borderRadius: '6px',
              width:'49%',
              py:'13px',
              textAlign:'center',
            },
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'인기 1:1 거래 회사', 'clickContent':`매물 모아보기`});_ctx.$emit('btnClick','shareSellAll')})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, {
                    css: {
              border: '1px solid #EEF1F7',
              borderRadius: '6px',
              width:'49%',
              py:'13px',
              textAlign:'center',
            },
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'인기 1:1 거래 회사', 'clickContent':`조합원 자격 팔기`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.$emit('btnClick','sellMyShareSell'))})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_intersect_box, { css: {height: 50} }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakeList, (stake, idx) => {
                    return (_openBlock(), _createBlock(_component_ag_box_s, {
                      key: stake.stockItemId,
                      css: {
              dp: '20px', borderBottom:'1px solid #F9F9FB', mb: '15px',
              pb: '15px', dp: 'flex', alignItems:'center', dd:'row',
              justifyContent: 'space-between',
            },
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'인기 1:1 거래 회사', 'clickContent':`${stake.stockItemName}`});_ctx.$emit('companyClick', stake.stockItemId)}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {dp: 'flex', alignItems:'center', typography:'main12r', fontWeight: '700', width:'20px'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(idx+1), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ag_box_s, { css: {width:50} }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("img", {
                                class: "img-circle img-responsive",
                                src: stake.companyLogo ? stake.companyLogo : '/assets/icon/company_default_img.png',
                                onerror: "this.src='/assets/icon/company_default_img.png'",
                                style: {"flex-shrink":"0"}
                              }, null, 8, _hoisted_7),
                              _hoisted_8
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ag_box_s, { css: {
                minWidth:'160px',
              } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_box_s, { css: {
                  typography:'text17m',
                } }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(stake.stockItemName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ag_box_s, { css: {
                  typography:'text12r',
                  color:'gray3',
                  dp:'flex',
                  dd:'row',
                } }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_box_s, { css: {
                    mr:'4px',
                    width:'12px',
                    height:'12px',
                    lineHeight: '17px',

                  } }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ag_text_s, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(stake.likeCount), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ag_text_s, { css: {
                    mx:'4px',
                    color:'bg2',
                  } }, {
                                  default: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ag_text_s, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.numberToKorean(stake.sellAmount)) + "원 거래 ", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ag_box_s, {
                          css: {
                textAlign:'right',
                typography:'text14r',
                dp:'block',
                color: (Number(stake.sellCount)===0?'gray4':'black'),
                minWidth:'90px',
              }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text_s, { css: {
                  dp:'block'
                } }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$filters.currency(stake.minPrice)) + " 원 ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            (stake.minPrice!=stake.maxPrice)
                              ? (_openBlock(), _createBlock(_component_ag_text_s, {
                                  key: 0,
                                  css: {
                  dp:'block'
                }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" ~ " + _toDisplayString(_ctx.$filters.currency(stake.maxPrice)) + " 원 ", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["css"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}